import { NavigationItem } from "@/config/navigation/types";
import { getItemPath } from "./get-item-path";

export const isItemActive = (item: NavigationItem, location: string): boolean => {
  const path = getItemPath(item);
  if (path && (location === path || location.startsWith(`${path}/`))) {
    return true;
  }

  return item.children?.some((child) => isItemActive(child, location)) ?? false;
};
